import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import VKYC_CAMERA from '../images/vkyc-camera.png';
import VKYC_PERSON from '../images/vkyc-person.png';
import { useLazyGetVkycDetailsQuery } from '../lib/services/vkycApi';
import { VKYC_STATUS } from '../lib/util/utilities';
import "../scss/vkycStyles.scss";

const VkycCard = ({ onCompleteClick, setIsLoading }) => {
    const [vkycStatus, setVkycStatus] = useState("");
    const [showVkycCard, setShowVkycCard] = useState(false);
    const [showVkycCtaValue, setShowVkycCtaValue] = useState(false);
    const [getVkycDetails, { data: vkycData }] = useLazyGetVkycDetailsQuery();
    const location = useLocation()
    const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search])
    const jwt = useMemo(() => queryParams.get('jwt_token'), [queryParams])
    const secret = useMemo(() => queryParams.get('secret'), [queryParams])

    useEffect(() => {
        const jwt_token = jwt || localStorage.getItem('jwt');
        const scrt = secret || localStorage.getItem('secret');
        if (jwt_token && scrt) {
            getVkycDetails({ jwt_token, scrt });
        }
    }, [jwt, secret, getVkycDetails]);

    useEffect(() => {
        if (!vkycData) return;
        // TODO: set vkycStatus and showVkycCard from vkycData when API response shape is known
        setVkycStatus(vkycData?.vkyc_status ?? '');
        setShowVkycCard(vkycData.shownudge);
    }, [vkycData]);

  useEffect(() => {
    const showVkycCta = (vkycStatus === VKYC_STATUS.INITIATED
        || vkycStatus === VKYC_STATUS.SCHEDULED 
        || vkycStatus === VKYC_STATUS.LIVE
        || vkycStatus === VKYC_STATUS.REJECTED
        || vkycStatus === VKYC_STATUS.ASSIGNED
        || vkycStatus === VKYC_STATUS.FRESH);

      setShowVkycCtaValue(showVkycCta);
  }, [vkycStatus]);


  const ctaText = () => {
    if(vkycStatus === VKYC_STATUS.INITIATED || vkycStatus === VKYC_STATUS.REJECTED || vkycStatus === VKYC_STATUS.FRESH){
      return "Complete VKYC";
    }else if(vkycStatus === VKYC_STATUS.LIVE || vkycStatus === VKYC_STATUS.SCHEDULED || vkycStatus === VKYC_STATUS.ASSIGNED){
      return  "Resume";
    }
    return "";
  }
  if(showVkycCard) {
    return (
      <div className="video-kyc-card">
        {/* LEFT SIDE */}
          <div className="left-side">
            <p className="left-side-title">One quick step</p>
            <p className="left-side-description">Complete video verification to keep your account active</p>
            {showVkycCtaValue && <button onClick={onCompleteClick} className="left-side-button">{ctaText()} <img src={VKYC_CAMERA} alt='' width={24} height={24} /></button>}
          </div>
  
          {/* RIGHT SIDE */}
          <div className="right-side">
            <img src={VKYC_PERSON} alt='' width={85} height={124} />
          </div>
      </div>
    )
  }else{
    return null;
  };
}

export default VkycCard;